'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

const APP_MODE_KEY = 'turbosheet_app_mode';

export default function HomePage() {
  const router = useRouter();

  useEffect(() => {
    try {
      const mode = localStorage.getItem(APP_MODE_KEY);
      if (mode === 'cloud') {
        router.replace('/cloud/analysis');
      } else {
        router.replace('/data-analysis');
      }
    } catch {
      router.replace('/data-analysis');
    }
  }, [router]);

  return (
    <div className="min-h-screen bg-[#0a0a0f] flex items-center justify-center">
      <div className="w-6 h-6 border-2 border-[#0ea5e9]/30 border-t-[#0ea5e9] rounded-full animate-spin" />
    </div>
  );
}